import { Injectable } from '@angular/core';
import { UserID } from '@common/dto/user';
import { RoutePathBuilder } from '@ngspot/route-path-builder';
import { StateQuery } from '../../my/state';
import { MY } from './route-strings';

@Injectable({ providedIn: 'any' })
export class RoutesForMy extends RoutePathBuilder {
  private get stateQuery() {
    return this.injector.get(StateQuery);
  }

  search() {
    return this.url(MY.SEARCH);
  }

  searchSaveSuccess() {
    const user = this.stateQuery.user;
    return user?.isQuestionnaireComplete || user?.hasStartedLooking
      ? this.match()
      : this.questionnaire();
  }

  startLooking() {
    const user = this.stateQuery.user;
    return user?.aboutMe ? this.match() : this.pictures();
  }

  questionnaire() {
    return this.url(MY.QUESTIONNAIRE);
  }

  pictures() {
    return this.url(MY.PICTURES);
  }

  about() {
    return this.url(MY.ABOUT);
  }

  setMyInfo() {
    return this.url(MY.MY_INFO);
  }

  activate() {
    return this.url(MY.ACTIVATE);
  }

  match(matchId?: UserID) {
    return this.urlFromCommands([MY.MATCH, matchId]);
  }

  seenAllMatches() {
    return this.url(MY.SEEN_ALL_MATCHES);
  }

  messages() {
    return this.url(MY.MESSAGES);
  }

  chat(matchId?: UserID) {
    return this.urlFromCommands([MY.CHAT, matchId]);
  }

  notifications() {
    return this.url(MY.NOTIFICATIONS);
  }

  profile() {
    return this.url(MY.PROFILE);
  }
}
